module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//10.jpg?1e43295f05ac0648df191e66dbaf7d5f";